import axiosPackage from "axios";

const getBaseUrl = () => {
  const proto = process.env.REACT_APP_API_PROTOCOL ?? "https://";
  const subdomain = process.env.REACT_APP_API_SUBDOMAIN ?? false;
  const domain =
    process.env.REACT_APP_API_DOMAIN ??
    window.location.hostname.replace(
      /^(staging-|preview-|testing-)?volunteer\./,
      ""
    );
  const path = process.env.REACT_APP_API_PATH ?? "/api/";

  return [proto, subdomain ? `${subdomain}.` : "", domain, path].join("");
};

const axios = axiosPackage.create({
  baseURL: getBaseUrl(),
  headers: {
    "Content-Type": "application/json",
    Accept: "application/json",
  },
  
  withCredentials: false,
});

// Add Authorization header if token exists
axios.interceptors.request.use(
  async (config) => {
    const token = localStorage.getItem("sva_webapp_token"); // pull token if exists (app-specific key to avoid conflicts)

    config.baseURL = getBaseUrl();
    config.headers = {
      ...config.headers,
      "Content-Type": "application/json",
      Accept: "application/json",
    };

    if (token) {
      config.headers.Authorization = `Bearer ${token}`; 
    }

    return config;
  },
  (error) => Promise.reject(error)
);

export default axios;
